import { first } from 'lodash'
import { Fragment, useState } from 'react'
import { OrderAPI } from '../../apis/OrderAPI'
import { loginAsCustomer } from '../../helpers/account'
import { getErrorMessage, log } from '../../helpers/utils'
import { ModalStore } from '../../state/ModalStore'
import { UserStore } from '../../state/UserStore'
import ErrorAlert from '../Alerts/ErrorAlert'
import Loader from '../Loader'
import ModalMainWrapper from './ModalMainWrapper'
import ModalHeader from './ModalHeader'
import ModalFooter from './ModalFooter'
import ModalContentWrapper from './ModalContentWrapper'
import ModalContent from './ModalContent'

export default function ShopAsCustomerModal() {
    const skim = ModalStore((state) => state.skim)

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const setUser = UserStore((state) => state.save)

    // const [customerId, setCustomerId] = useState('')
    const [email, setEmail] = useState('')

    function closeModal() {
        skim()
    }

    const searchCustomer = async (e) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            setLoading(true)
            setError('')
            if (String(email).trim() === '')
                throw new Error('Please enter a valid customer email id.')
            const { data } = await OrderAPI.searchCustomerByEmail(email)
            if (data.length < 1)
                throw new Error('No customer found with this email id.')
            const user = await loginAsCustomer(first(data).id)
            log('user', user)
            setUser(user)
            closeModal()
            location.reload()
        } catch (e) {
            setError(getErrorMessage(e))
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            <ModalMainWrapper size="small">
                <ModalContentWrapper size="md">
                    <ModalHeader title="Shop as Customer" />
                    <ModalContent>
                        <form onSubmit={searchCustomer} className="my-4">
                            <div className="mt-2">
                                <p className="text-sm text-gray-500 space-y-2 flex flex-col">
                                    <span className="font-medium">
                                        Enter Customer Email
                                    </span>
                                    <input
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        type="email"
                                        className="focus:ring-0 border-2 border-gray-300 rounded focus:border-olh"
                                    />
                                </p>
                            </div>
                            <ModalFooter
                                confirmText=" Login as Customer"
                                type="submit"
                            />
                        </form>
                        {error && <ErrorAlert error={error} />}
                    </ModalContent>
                </ModalContentWrapper>
            </ModalMainWrapper>
        </>
    )
}
